<!-- <div class="sidebar__header">
  <a id="sidebar-toggle navbar " class="sidebar-toggle hidden-xs hidden-sm">
    <a href="javascript:void(0)" class="navbar-toggler" aria-expanded="false" aria-label="Toggle navigation"
      (click)="toggleNav()">
      <span class="fa fa-navicon" [ngClass]="{'fa-remove': navLarge,'fa-navicon':!navLarge }"></span>
    </a>
  </a>
  <div class="sidebar__header-title"></div>
</div> -->

<ul id="rootsidebar">
  <li *ngFor="let item of navList;let i = index">
    <a href="javascript:void(0)" (click)="item.open = !item.open" [routerLink]="item.url"
      [routerLinkActive]="['active']">
      <img src="{{item.imgPath}}" class="nav-icon" alt="{{item.name}}" />
      <!-- <span [ngClass]="item.icon" class="nav-icon"> </span> -->
      <span *ngIf="item.profileID" class="text-capitalize"> {{item?.profileID}} </span>
      <span *ngIf="!item.profileID"> {{item?.name}} </span>
      <span *ngIf="navLarge && item.links.length" class="arrow fa"
        [ngClass]="{'fa-chevron-up': item.open , 'fa-chevron-down': !item.open }"></span>
    </a>
    <ul class="side_bar_child" [ngClass]="{'open' : item.open  }">
      <li *ngFor="let child of item.links"> <a [routerLink]="child.url" [routerLinkActive]="['active']"
          class="{{item?.class}}">
          {{ child?.name }} </a></li>
    </ul>
  </li>
  <li>
    <a href="javascript:void(0)" (click)="logout()">
      <img src="../../../assets/images/admin/Logout.png" class="nav-icon" alt="Logout" />Logout
      <!-- <span class="fa fa-sign-out"></span> -->
    </a>
  </li>
</ul>
<!-- <div class="logout">
  <a href="javascript:void(0)" class="logoutlink text-warning" (click)="logout()">Logout <span
      class="fa fa-sign-out"></span></a>
  <a href="javascript:void(0)" (click)="logout()">
      <img  src="../../../assets/images/logout.svg" class="nav-icon"/>
      <span>Logout</span>
    </a>
</div> -->
